export default "__VITE_ASSET__DLHRxciQ__"